import React from "react";
import { Activity } from "lucide-react";
import { formatIDR, formatPct } from "../lib/format";

const SubCard = ({ label, period, value, change, changeLabel, footer, valueColor, testId }) => (
  <div className="mi-sub" data-testid={testId}>
    <div className="mi-sub-head">
      <span className="mi-sub-lbl">{label}</span>
      {period && <span className="mi-sub-period">{period}</span>}
    </div>
    {changeLabel && (
      <div className="mi-sub-change-row">
        <span>{changeLabel}</span>
        <span className={change > 0 ? "up" : change < 0 ? "down" : "flat"}>
          {change != null ? formatPct(change, 2) : "—"}
        </span>
      </div>
    )}
    <div className="mi-sub-value" style={valueColor ? { color: valueColor } : null}>
      {value}
    </div>
    {footer && <div className="mi-sub-footer">{footer}</div>}
  </div>
);

export const MainIndicators = ({ indicators }) => {
  if (!indicators) {
    return (
      <div className="nms-card bottom-card" data-testid="main-indicators-card">
        <div className="bc-head">
          <h3 className="bc-title">
            <Activity size={14} /> MAIN INDICATORS
          </h3>
          <span className="bc-live">● LIVE</span>
        </div>
        <div className="loading-tile">Loading…</div>
      </div>
    );
  }

  const monthIDX = ["JAN", "FEB", "MAR", "APR", "MEI", "JUN", "JUL", "AGT", "SEP", "OKT", "NOV", "DES"];
  const inf = indicators.inflasi || {};
  const ihk = indicators.ihk || {};
  const kurs = indicators.kurs || {};
  const brent = indicators.brent || {};

  return (
    <div className="nms-card bottom-card main-indicators" data-testid="main-indicators-card">
      <div className="bc-head">
        <h3 className="bc-title">
          <Activity size={14} /> MAIN INDICATORS
        </h3>
        <span className="bc-live">● LIVE</span>
      </div>

      <div className="mi-grid">
        <SubCard
          testId="indicator-inflasi"
          label="INFLASI"
          period={inf.month && monthIDX[inf.month - 1] ? `${monthIDX[inf.month - 1]} ${inf.year ?? ""}` : ""}
          value={
            <div className="mi-mom-yoy">
              <div>
                <span className="lab">MoM</span>
                <span className="num">{(inf.mom ?? 0).toFixed(2)}%</span>
              </div>
              <div>
                <span className="lab">YoY</span>
                <span className="num">{(inf.yoy ?? 0).toFixed(2)}%</span>
              </div>
            </div>
          }
          valueColor="var(--nms-emerald-soft)"
        />
        <SubCard
          testId="indicator-ihk"
          label="IHK"
          period={ihk.month && monthIDX[ihk.month - 1] ? `${monthIDX[ihk.month - 1]} ${ihk.year ?? ""}` : ""}
          change={ihk.change}
          changeLabel=" "
          value={<span>{(ihk.value ?? 0).toFixed(2)}</span>}
        />
        <SubCard
          testId="indicator-kurs"
          label="KURS"
          period="(USD/IDR)"
          footer={`THRESHOLD Rp ${formatIDR(16500)}`}
          change={kurs.gap_percentage}
          changeLabel=" "
          value={<span>Rp {formatIDR(kurs.value)}</span>}
          valueColor="var(--nms-emerald-soft)"
        />
        <SubCard
          testId="indicator-brent"
          label="BRENT OIL"
          period=""
          footer={`THRESHOLD $70`}
          change={brent.gap_percentage}
          changeLabel=" "
          value={<span>${(brent.value ?? 0).toFixed(2)}</span>}
          valueColor="var(--nms-red)"
        />
      </div>
    </div>
  );
};

export default MainIndicators;
